class JsonTool {
  static convertToQueryString(data) {
    let arr = [];
    Object.keys(data || {})?.forEach((key) => {
      if (
        data[key] != null &&
        data[key] != undefined &&
        data[key] != "null" &&
        data[key] != "undefined" &&
        data[key] != ""
      ) {
        if (Array.isArray(data[key])) {
          let values = data[key]?.map((item) => item)?.join(",");
          arr.push(
            encodeURIComponent(key) +
              "=" +
              "[" +
              encodeURIComponent(values) +
              "]"
          );
        } else {
          arr.push(
            encodeURIComponent(key) + "=" + encodeURIComponent(data[key])
          );
        }
      }
    });
    return arr.join("&");
  }
  static convertToQueryStringWithArrayData(data) {
    let arr = [];
    Object.keys(data || {})?.forEach((key) => {
      if (
        data[key] != null &&
        data[key] != undefined &&
        data[key] != "null" &&
        data[key] != "undefined" &&
        data[key] != ""
      ) {
        if (Array.isArray(data[key])) {
          let values = data[key]
            ?.map((item) => JSON.stringify(item))
            ?.join(",");
          arr.push(encodeURIComponent(key) + "=" + "[" + values + "]");
        } else {
          arr.push(
            encodeURIComponent(key) + "=" + encodeURIComponent(data[key])
          );
        }
      }
    });
    return arr.join("&");
  }
  static validateEmail = (value) => {
    const pattern = new RegExp(
      /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
    );
    let check = false;
    if (!pattern.test(value)) {
      check = true;
    }
    return check;
  };
  // Hàm để chuyển đổi một tập tin thành base64
  static convertToBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = () => {
        resolve(reader.result);
      };

      reader.onerror = (error) => {
        reject(error);
      };
    });
  }

  //Format số
  static formatNumber = (number) => {
    if (number) {
      return new Intl.NumberFormat("en-US").format(number);
    }
  };

  //dùng với tabs, tab
  static a11yProps = (index) => {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  };

  //dung cho vertical-tab
  static a11yVerticalProps(index) {
    return {
      id: `vertical-tab-${index}`,
      "aria-controls": `vertical-tabpanel-${index}`,
    };
  }
}
export { JsonTool };
